import { isErrorStatus } from '@audience-republic/audience-manager-shared/api/utils'
import type { CustomApiError } from '@audience-republic/audience-manager-shared/api/types'
import type { ApiToken } from './types'
import type { ArAxios } from '@/plugins/ar-axios'

export default (axios: ArAxios) => ({

  async fetchAll(promoterOid: number): Promise<ApiToken[]> {
    // TO DO: Move back after debugging
    const { data, status } = await axios.sg.get(`/promoter/${promoterOid}/api-token`)
    if (isErrorStatus(status)) {
      const apiError: CustomApiError = {
        name: 'Fetch api tokens error',
        message: `Error fetching api tokens`,
        status,
      }
      throw apiError
    }
    return data
  },

  async issue(promoterOid: number): Promise<ApiToken> {
    const { data, status } = await axios.sg.post(`/promoter/${promoterOid}/api-token`)
    if (isErrorStatus(status)) {
      const apiError: CustomApiError = {
        name: 'Issue api tokens error',
        message: `Error issuing api tokens`,
        status,
      }
      throw apiError
    }
    return data
  },

  async revoke(promoterOid: number, apiTokenOid: number): Promise<boolean> {
    const { status } = await axios.sg.delete(`/promoter/${promoterOid}/api-token/${apiTokenOid}`)
    if (isErrorStatus(status)) {
      const apiError: CustomApiError = {
        name: 'Delete api tokens error',
        message: `Error deleting api tokens`,
        status,
      }
      throw apiError
    }
    return (status === 204)
  },

})
